export default {
    profile: {
        title: 'Settings',
        adminInformation: 'Admin Information',
        businessInformation: 'Business Information',
        instructorInformation: 'Instructor Information',
        userInformation: 'Member Information',
        passwordInformation: 'Password Settings',
        successMessage: 'Password has been updated',
        successMessageAvatarUpdated: 'Personal Avatar Updated',
        successMessageAvatarDeleted: 'Personal Avatar Deleted',
        successMessagePersonalInformation: 'Personal Information Updated',
        errorMessage: 'Invalid current password',
        fields: {
            fullName: 'Full Name',
            businessName: 'Business Name',
            email: 'Email',
            contactPhone: 'Contact Phone',
            password: 'Password',
            newPassword: 'New Password',
            confirmNewPassword: 'Confirm New Password'
        },
        reminders: {
            pushNotificationLabel: 'Push notifications in App',
            sendEmailLabel: 'Send to Email',
            datePickerLabel: 'When would you like to be reminded to meditate?'
        },
        businessDataParameters: {
            title: 'Business Data Parameters',
            activeSince: 'Active Since: ',
            currentMaxCapacity:
                'Current Max Capacity: <strong>{capacity}</strong>'
        },
        navigation: [
            {
                title: 'User Information',
                titleMobile: 'Information',
                url: '/profile/user-information',
                icon: 'face',
                access: ['admin', 'instructor', 'champion', 'member']
            },
            {
                title: 'Subscription Details',
                titleMobile: 'Subscription',
                icon: 'payment',
                url: '/profile/subscription-details',
                access: ['member'],
                status: [
                    'trial',
                    'expired',
                    'discontinued',
                    'annual',
                    'monthly'
                ]
            },
            {
                title: 'Reminders',
                titleMobile: 'Reminders',
                url: '/profile/reminders',
                icon: 'alarm',
                access: ['member']
            },
            {
                title: 'Password Settings',
                titleMobile: 'Password',
                url: '/profile/password',
                icon: 'settings',
                access: ['admin', 'instructor', 'champion', 'member']
            }
        ]
    }
};
